import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';

interface ShowMoreButtonProps {
  onClickShowMoreInfo: () => void;
  fontSize?: string;
}

const defaultProps = { fontSize: '25px' };

const ShowMoreButton: FC<ShowMoreButtonProps> = ({ onClickShowMoreInfo, fontSize }) => (
  <Tooltip title="Show more info">
    <IconButton size="small" onClick={onClickShowMoreInfo} aria-label="Show more info">
      <span style={{ fontSize }}>
        <Icon iconId="info" />
      </span>
    </IconButton>
  </Tooltip>
);

ShowMoreButton.defaultProps = defaultProps;

export default ShowMoreButton;
